import { styled } from "@vitality-ds/system";
import MaskedInput from "react-text-mask";
import baseTextInputStyles from "../../styles/BaseTextInput.styles";

/* eslint-disable-next-line import/prefer-default-export */
export var BaseMaskedTextInput = styled(MaskedInput, baseTextInputStyles);